import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { blockUnblockEvent, blockUnblockEventType, blockUnblockMarketType, fetchBlockedEvents, fetchBlockedEventTypes, fetchBlockedMarketTypes } from '../../../services/block-markets';
export const fetchBlockedEventTypesAsync = createAsyncThunk(
    'blockMarkets/fetchBlockedEventTypes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchBlockedEventTypes();
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch sports events');
        }
    }
);

export const blockUnblockEventTypeAsync = createAsyncThunk(
    'blockMarkets/blockUnblockEventType',
    async (data, { rejectWithValue }) => {
        try {
            const response = await blockUnblockEventType(data);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to block/unblock event type');
        }
    }
)

export const fetchBlockedEventsAsync = createAsyncThunk(
    'blockMarkets/fetchBlockedEvents',
    async (event_type, { rejectWithValue }) => {
        try {
            const response = await fetchBlockedEvents(event_type);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch blocked events');
        }
    }
)

export const blockUnblockEventAsync = createAsyncThunk(
    'blockMarkets/blockUnblockEvent',
    async (data, { rejectWithValue }) => {
        try {
            const response = await blockUnblockEvent(data);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to block/unblock event');
        }
    }
)

export const fetchBlockedMarketTypesAsync = createAsyncThunk(
    'blockMarkets/fetchBlockedMarketTypes',
    async (event_id, { rejectWithValue }) => {
        try {
            const response = await fetchBlockedMarketTypes(event_id);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch blocked market types');
        }
    }
)

export const blockUnblockMarketTypeAsync = createAsyncThunk(
    'blockMarkets/blockUnblockMarketType',
    async (data, { rejectWithValue }) => {
        try {
            const response = await blockUnblockMarketType(data);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to block/unblock market type');
        }
    }
)
const eventsSlice = createSlice({
    name: 'blockMarkets',
    initialState: {
        eventTypes: [],
        events: [],
        marketTypes: [],
        loading: false,
        error: null
    },
    reducers: {
        clearBlockMarkets(state) {
            state.eventTypes = [];
            state.events = [];
            state.marketTypes = [];
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlockedEventTypesAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlockedEventTypesAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.eventTypes = action.payload.data || [];
                state.error = null;
            })
            .addCase(fetchBlockedEventTypesAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch block markets';
                state.eventTypes = [];
            })

            .addCase(blockUnblockEventTypeAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(blockUnblockEventTypeAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(blockUnblockEventTypeAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchBlockedEventsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlockedEventsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.events = action.payload.data || [];
                state.error = null;
            })
            .addCase(fetchBlockedEventsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch blocked events';
                state.events = [];
            })

            .addCase(blockUnblockEventAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(blockUnblockEventAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(blockUnblockEventAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchBlockedMarketTypesAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlockedMarketTypesAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.marketTypes = action.payload.data || [];
                state.error = null;
            })
            .addCase(fetchBlockedMarketTypesAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch blocked market types';
                state.marketTypes = [];
            })
            .addCase(blockUnblockMarketTypeAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(blockUnblockMarketTypeAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(blockUnblockMarketTypeAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });


    }
});


export default eventsSlice.reducer;